<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="" elevation="" max-width="">
          <v-card-title class="justify-center"> MODIFICAR CATEGORIA </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p>
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'inicioPanel' }"
                    >Inicio</router-link
                  >
                  /
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'categoriasPanel' }"
                    >Categorias</router-link
                  >
                  /
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{
                      name: 'categoriasEditarPanel',
                      params: { idcategoria: $route.params.idcategoria },
                    }"
                    >Editar</router-link
                  >
                </p>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12 text-center" v-show="!mostrarContenido">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="100"
                  :width="7"
                ></v-progress-circular>
              </v-col>
            </v-row>

            <v-form
              @submit.prevent="modificar()"
              v-show="mostrarContenido"
              :disabled="processForm"
            >
              <v-row>
                <v-col cols="12">
                  <v-alert
                    type="error"
                    v-model="alertError"
                    dismissible
                    ref="mensajeError"
                    id="mensajeError"
                  >
                    <ul v-for="(errors, index) in listErrors" :key="index">
                      <li v-text="errors[0]"></li>
                    </ul>
                  </v-alert>
                </v-col>

                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                  <v-text-field
                    dense
                    label="Nombre (*)"
                    v-model="categoria.nombre"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                  <v-text-field
                    dense
                    label="Titulo web"
                    v-model="categoria.titulo_web"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    rows="3"
                    clearable
                    clear-icon="mdi-close-circle"
                    label="Descripción"
                    v-model="categoria.descripcion"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <p>Imagen:</p>
                  <input
                    style="display: none"
                    type="file"
                    ref="iptImagen"
                    @change.prevent="cargarImagen"
                    accept="image/*"
                  />
                  <div class="custom-my-dropzone">
                    <v-row>
                      <v-col cols="12" class="text-center" v-show="urlImagen === ''">
                        <v-btn
                          :loading="loaderImagen"
                          color="primary"
                          @click="
                            $refs.iptImagen.value = '';
                            $refs.iptImagen.click();
                          "
                        >
                          <v-icon left>mdi-cloud-upload-outline</v-icon> CARGAR IMAGEN
                        </v-btn>
                      </v-col>
                      <v-col cols="12" class="text-center" v-show="urlImagen !== ''">
                        <v-btn icon color="red" small @click.prevent="eliminarImagen">
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                        <v-img :src="urlImagen" height="200" contain> </v-img>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-select
                    dense
                    item-text="texto"
                    item-value="valor"
                    :items="cmbEstado"
                    label="Estado(*)"
                    outlined
                    v-model="categoria.estado"
                  ></v-select>
                </v-col>

                <v-col cols="12" class="text-center">
                  <v-btn
                    class="mr-2"
                    type="submit"
                    :loading="processForm"
                    color="success"
                    large=""
                  >
                    <v-icon left="" large="">mdi-content-save-edit</v-icon> MODIFICAR
                  </v-btn>
                  <v-btn
                    :to="{ name: 'categoriasPanel' }"
                    type="button"
                    :loading="processForm"
                    color="error"
                    large=""
                  >
                    <v-icon left="" large="">mdi-close</v-icon> CANCELAR
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      categoria: {
        _method: "PUT",
        idcategoria: "",
        nombre: "",
        titulo_web: "",
        google: "",
        descripcion: "",
        imagen: "",
        estado: 1,
      },
      cmbEstado: [
        {
          texto: "Habilitado",
          valor: 1,
        },
        {
          texto: "Inhabilitado",
          valor: 0,
        },
      ],
      mostrarContenido: false,
      processForm: false,
      listErrors: [],
      alertError: false,
      loaderImagen: false,
      urlImagen: "",
    };
  },

  methods: {
    cargarImagen(event) {
      this.loaderImagen = true;

      if (this.urlImagen !== "") {
        this.$toasted.error("Ya hay un archivo cargado");
        this.loaderImagen = false;
        return;
      }

      if (event.target.files.length > 0) {
        let imagen = event.target.files[0];
        this.urlImagen = URL.createObjectURL(imagen);
        this.categoria.imagen = imagen;
      }

      this.loaderImagen = false;
    },

    eliminarImagen() {
      this.urlImagen = "";
      this.categoria.imagen = "";
      this.axios
        .post("api/panel/categorias/eliminarArchivo", {
          idcategoria: this.categoria.idcategoria,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$toasted.success(response.data.data);
          } else {
            this.$toasted.error("Error al eliminar el archivo");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDatos() {
      this.mostrarContenido = false;
      this.axios({
        method: "GET",
        url: "api/panel/categorias/" + this.$route.params.idcategoria + "/edit",
      })
        .then((response) => {
          let status = response.status;
          if (status === 200) {
            let categoria = response.data.data;

            this.categoria.idcategoria = categoria.idcategoria;
            this.categoria.nombre = categoria.nombre;
            this.categoria.titulo_web = categoria.titulo_web;
            this.categoria.descripcion = categoria.descripcion;
            this.categoria.google = categoria.google;

            if (categoria.imagen != null) {
              this.urlImagen = this.assetAWS("categorias/" + categoria.imagen);
            }

            this.categoria.estado = categoria.estado;
          }

          this.mostrarContenido = true;
        })
        .catch((error) => {
          this.$toasted.error("Ocurrio un error al buscar este registro", {
            icon: "mdi-close",
          });

          this.$router.push({
            name: "categoriasPanel",
          });
        })
        .finally(() => {});
    },

    modificar() {
      this.processForm = true;
      this.alertError = false;

      this.axios({
        method: "POST",
        url: "api/panel/categorias/" + this.categoria.idcategoria,
        data: this.serialize(this.categoria),
      })
        .then((response) => {
          let status = response.status;
          if (status === 200) {
            this.$toasted.success(response.data.data, {
              icon: "mdi-check-bold",
            });
            this.$router.push({
              name: "categoriasPanel",
            });
          }
        })
        .catch((error) => {
          let status = error.response.status;
          if (status === 422) {
            let arrErrors = error.response.data.errors;
            this.listErrors = Object.values(arrErrors);
            this.alertError = true;
            this.$vuetify.goTo(this.$refs.mensajeError);
          } else {
            this.$toasted.error("Ocurrio un error al modificar este registro", {
              icon: "mdi-close",
            });
          }
        })
        .finally(() => {
          this.processForm = false;
        });
    },
  },
  created() {
    if (!this.validarPermiso("categorias.editar")) {
      this.$toasted.error("Usted no tiene permisos para esta sección", {
        icon: "mdi-close",
      });

      this.$router.push({
        name: "inicioPanel",
      });
    }
    window.scrollTo(0, 0);

    this.getDatos();
  },
};
</script>
